import { SimBadge } from './sim-badge.js';

/**
 * Register all custom elements exactly once.
 *
 * WHY centralised + guarded: defining the same tag twice throws; guarding keeps
 * registration idempotent across HMR and tests.
 */
export function registerComponents(): void {
  define(SimBadge.tagName, SimBadge);
}

/** Idempotent customElements.define (defining a tag twice throws). */
export function define(tag: string, ctor: CustomElementConstructor): void {
  if (!customElements.get(tag)) customElements.define(tag, ctor);
}
